export default __webpack_public_path__ + "static/media/Emotional07.b71b91db.png";